// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "component/servo/v1/servo.proto" (package "viam.component.servo.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { GetGeometriesResponse } from "../../../common/v1/common";
import { GetGeometriesRequest } from "../../../common/v1/common";
import { GetStatusResponse } from "../../../common/v1/common";
import { GetStatusRequest } from "../../../common/v1/common";
import { DoCommandResponse } from "../../../common/v1/common";
import { DoCommandRequest } from "../../../common/v1/common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../../google/protobuf/struct";
/**
 * @generated from protobuf message viam.component.servo.v1.MoveRequest
 */
export interface MoveRequest {
    /**
     * the name of the servo, as registered
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * the degrees by which to rotate the servo.
     *
     * @generated from protobuf field: uint32 angle_deg = 2;
     */
    angleDeg: number;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.servo.v1.MoveResponse
 */
export interface MoveResponse {
}
/**
 * @generated from protobuf message viam.component.servo.v1.GetPositionRequest
 */
export interface GetPositionRequest {
    /**
     * the name of the servo, as registered
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.servo.v1.GetPositionResponse
 */
export interface GetPositionResponse {
    /**
     * the degrees from neutral by which the servo is currently rotated.
     *
     * @generated from protobuf field: uint32 position_deg = 1;
     */
    positionDeg: number;
}
/**
 * @generated from protobuf message viam.component.servo.v1.StopRequest
 */
export interface StopRequest {
    /**
     * Name of a servo
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.component.servo.v1.StopResponse
 */
export interface StopResponse {
}
/**
 * @generated from protobuf message viam.component.servo.v1.Status
 */
export interface Status {
    /**
     * @generated from protobuf field: uint32 position_deg = 1;
     */
    positionDeg: number;
    /**
     * @generated from protobuf field: bool is_moving = 2;
     */
    isMoving: boolean;
}
/**
 * @generated from protobuf message viam.component.servo.v1.IsMovingRequest
 */
export interface IsMovingRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.component.servo.v1.IsMovingResponse
 */
export interface IsMovingResponse {
    /**
     * @generated from protobuf field: bool is_moving = 1;
     */
    isMoving: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class MoveRequest$Type extends MessageType<MoveRequest> {
    constructor() {
        super("viam.component.servo.v1.MoveRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "angle_deg", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.servo.v1.MoveRequest
 */
export const MoveRequest = new MoveRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveResponse$Type extends MessageType<MoveResponse> {
    constructor() {
        super("viam.component.servo.v1.MoveResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.servo.v1.MoveResponse
 */
export const MoveResponse = new MoveResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPositionRequest$Type extends MessageType<GetPositionRequest> {
    constructor() {
        super("viam.component.servo.v1.GetPositionRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.servo.v1.GetPositionRequest
 */
export const GetPositionRequest = new GetPositionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPositionResponse$Type extends MessageType<GetPositionResponse> {
    constructor() {
        super("viam.component.servo.v1.GetPositionResponse", [
            { no: 1, name: "position_deg", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.servo.v1.GetPositionResponse
 */
export const GetPositionResponse = new GetPositionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopRequest$Type extends MessageType<StopRequest> {
    constructor() {
        super("viam.component.servo.v1.StopRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.servo.v1.StopRequest
 */
export const StopRequest = new StopRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopResponse$Type extends MessageType<StopResponse> {
    constructor() {
        super("viam.component.servo.v1.StopResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.servo.v1.StopResponse
 */
export const StopResponse = new StopResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Status$Type extends MessageType<Status> {
    constructor() {
        super("viam.component.servo.v1.Status", [
            { no: 1, name: "position_deg", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "is_moving", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.servo.v1.Status
 */
export const Status = new Status$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsMovingRequest$Type extends MessageType<IsMovingRequest> {
    constructor() {
        super("viam.component.servo.v1.IsMovingRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.servo.v1.IsMovingRequest
 */
export const IsMovingRequest = new IsMovingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsMovingResponse$Type extends MessageType<IsMovingResponse> {
    constructor() {
        super("viam.component.servo.v1.IsMovingResponse", [
            { no: 1, name: "is_moving", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.component.servo.v1.IsMovingResponse
 */
export const IsMovingResponse = new IsMovingResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.component.servo.v1.ServoService
 */
export const ServoService = new ServiceType("viam.component.servo.v1.ServoService", [
    { name: "Move", options: { "google.api.http": { put: "/viam/api/v1/component/servo/{name}/move" }, "viam.common.v1.safety_heartbeat_monitored": true }, I: MoveRequest, O: MoveResponse },
    { name: "GetPosition", options: { "google.api.http": { get: "/viam/api/v1/component/servo/{name}/position" } }, I: GetPositionRequest, O: GetPositionResponse },
    { name: "Stop", options: { "google.api.http": { post: "/viam/api/v1/component/servo/{name}/stop" } }, I: StopRequest, O: StopResponse },
    { name: "IsMoving", options: { "google.api.http": { get: "/viam/api/v1/component/servo/{name}/is_moving" } }, I: IsMovingRequest, O: IsMovingResponse },
    { name: "DoCommand", options: { "google.api.http": { post: "/viam/api/v1/component/servo/{name}/do_command" } }, I: DoCommandRequest, O: DoCommandResponse },
    { name: "GetStatus", options: { "google.api.http": { get: "/viam/api/v1/component/servo/{name}/get_status" } }, I: GetStatusRequest, O: GetStatusResponse },
    { name: "GetGeometries", options: { "google.api.http": { get: "/viam/api/v1/component/servo/{name}/geometries" } }, I: GetGeometriesRequest, O: GetGeometriesResponse }
]);
